import { render, staticRenderFns } from "./JgpDragResize.vue?vue&type=template&id=27c31548&scoped=true&"
import script from "./JgpDragResize.vue?vue&type=script&lang=js&"
export * from "./JgpDragResize.vue?vue&type=script&lang=js&"
import style0 from "./JgpDragResize.vue?vue&type=style&index=0&id=27c31548&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c31548",
  null
  
)

export default component.exports